// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"incomplete-profile-desktop-content_component_wrapper__f_mj0"};